module.exports = __webpack_public_path__ + "img/icon-pagination-right-stop.2cb9ffa3.svg";